import {
    StackerAPI,
    StackerActions,
    FETCH_STARTED,
    FETCH_COMPLETED,
    byID,
    without,
    fetchAndReturn,
} from "./utils/utils"
import { unique } from "utils/utils"
import { STACK_SELECTED } from "./stackApi"

// CONSTANTS
export const TEMPLATES_FETCHED = "TEMPLATES_FETCHED"

// API
class TemplateApi extends StackerAPI {
    path = "templates/"
}
const templateApi = new TemplateApi()

class TemplateActions extends StackerActions {
    api = templateApi
    reducer = "templates"
    actionTypes = {
        fetched: TEMPLATES_FETCHED,
    }
}

const clone = (templateId, name, callback) => {
    return fetchAndReturn("clone?stack_id=" + templateId + "&stack_name=" + name, {
        method: "GET",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    }).then(callback())
}

let TA = new TemplateActions()
TA.actions = { ...TA.actions, clone }
export const templateActions = TA.actions

// STATE
const initialState = {
    templates: [],
    entities: {},
    fetching: [],
}

// REDUCERS
export function templateReducer(state = initialState, action) {
    var templates, template, fetching
    switch (action.type) {
        case TEMPLATES_FETCHED:
            return {
                ...state,
                templates: unique([
                    ...state.templates,
                    ...action.payload.map(template => template._sid),
                ]),
                entities: { ...state.entities, ...byID(action.payload) },
            }

        case FETCH_STARTED:
            return { ...state, fetching: [...state.fetching, action.key] }
        case FETCH_COMPLETED:
            fetching = state.fetching.filter(item => item !== action.key)
            return { ...state, fetching: fetching }

        case STACK_SELECTED:
            return initialState
        default:
            return state
    }
}

// SELECTORS
export const getTemplateEntities = state => state.templates.entities
export const getTemplates = state => {
    if (typeof state.templates.templates.map !== "function") debugger
    return state.templates.templates.map(templateId => state.templates.entities[templateId])
}

// HELPERS



// WEBPACK FOOTER //
// ./src/data/templateApi.js